import * as type from '@/utvStore/store/mutation-types'
import { ITEM_API } from '@/utvStore/store/API'
import pushErrorMessage from '@/utils/pushErrorMessage'
import { TAROT_TAG_ID } from '@/CONSTS/FORTUNE_INFO'
import { ACQUIRED_MENUS_NUMBER, CLOSED_MENUS_LSKEY } from '@/CONSTS/MENUS'

import moment from 'moment'
import {
  CHECK_HAVE_CLOSED_ITEMS,
  GET_CLOSED_ITEMS_CACHE,
  GET_FILTERED_TAG_ITEMS, RESET_TAGITEMS_FILTER,
  SET_CLOSED_ITEMS_LSKEY,
  SETSHOWN_CLOSED_ITEMS_CACHE,
  UPDATE_CLOSED_ITEMS_CACHE
} from '../mutation-types'
moment.locale('ja')

const FAV_CHECK_TIME = 500

const timeoutValue = !!location
  ? /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/.test(location.host) || /^localhost/.test(location.host) ? 30000 : 8000
  : 30000

// dbg.info('ITEM API Timeout Value: %s秒', timeoutValue / 1000)

const axiosInstance = axios.create({
  timeout: timeoutValue,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'content-type': 'application/json'
  }
})

const tvAxiosInstance = axios.create({
  timeout: 8000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'content-type': 'application/json'
  }
})

const TV_API_HOST_URL = {
  // local: 'https://worker-dot-zaptvtest.appspot.com',
  // dev: 'https://worker-dot-zaptvtest.appspot.com',
  // stg: 'https://worker-dot-zaptvpro.appspot.com',
  // prod: 'https://worker-dot-zaptvpro.appspot.com',

  // ↓新環境用
  local: 'https://zaptvtest-worker.uranai.tv/worker',
  dev: 'https://zaptvpro-worker.uranai.tv/worker',
  stg: 'https://zaptvpro-worker.uranai.tv/worker',
  prod: 'https://zaptvpro-worker.uranai.tv/worker'
}

const initialState = {
  selected: {},
  collection: [],
  recomends: [],
  itemData: [],
  subscrItemList: [],
  tagInfo: {
    currentTag: '0',
    isSeelater: false,
    seelaterNum: 0
  },
  currentTagData: {},
  favCheckList: [],
  subscVideoItems: [],
  isChangePartnerReset: false,
  categoryItems: [],
  catpageReferrer: '',
  catpageHistory: [],
  catpageReloadFlg: false,
  openedTextDetailID: 0,
  closedItems: [],
  closedItemsLSKEY: '',
  closedItemsTOKEN: '',
  tagItemFilter: []
}

const createData = (data = {}) => JSON.stringify(data)

const state = Object.assign({}, initialState)

const getters = {
  hasRecomends: _state => {
    const hasDisplayItems = _state.recomends.filter(recomend => !recomend.not_view).length > 0
    return _state.recomends.length > 0 && hasDisplayItems
  }
}

const actions = {
  // 一覧取得
  [type.GET_ITEMS]({ commit }, itemData = {}) {
    return axiosInstance.post(ITEM_API.getItems, itemData).then(
      res => {
        commit(type.GET_ITEMS, res.data)
      },
      error => {
        return Promise.reject(error)
      }
    )
  },
  /**
   * 単体の情報取得
   * @param Object data - { id: 'item_id' }
   */
  [type.GET_ITEM]({ commit }, data) {
    return axiosInstance.post(ITEM_API.getItem, data).then(
      res => {
        commit(type.GET_ITEM, res.data)
      },
      error => {
        return Promise.reject(error)
      }
    )
  },
  [type.RESET_ITEMS]({ commit }) {
    commit(type.RESET_ITEMS)
  },
  [type.SELECT_ITEM]({ commit }, data) {
    return axiosInstance.post(ITEM_API.getItem, data).then(
      res => {
        commit(type.SELECT_ITEM, res.data)
      },
      error => {
        error = pushErrorMessage(error)
        return Promise.reject(error)
      }
    )
  },
  [type.RESET_SELECTED_ITEM]({ commit }) {
    commit(type.RESET_SELECTED_ITEM)
  },
  /**
   * オススメ一覧の取得
   * @param {String} itemsId オススメ取得対象のitem_id
   */
  [type.GET_ITEM_RECOMENDS]({ commit }, itemsId) {
    return axiosInstance.get(`/api/recomend/${itemsId}`).then(
      res => {
        commit(type.GET_ITEM_RECOMENDS, res.data)
      },
      error => {
        return Promise.reject(error)
      }
    )
  },
  [type.RESET_ITEM_RECOMENDS]({ commit }) {
    commit(type.RESET_ITEM_RECOMENDS)
  },
  [type.GET_SUBSCRIPT_VIDEO]({ commit, state }, data) {
    const host = location.host
    const branch = host === '192.168.10.10' ? 'local' : /^dev/.test(host) ? 'dev' : /^stg/.test(host) ? 'stg' : 'prod'
    const datalist = {}
    const param = { subscript_store_product_id: [] }
    // dbg.info('Send To TV Data: %O', data)
    for (let key in data) {
      param['subscript_store_product_id'].push(parseInt(data[key]))
      datalist[key] = {
        subscrId: data[key]
      }
    }

    return tvAxiosInstance.post(`${TV_API_HOST_URL[branch]}/subscript/url_list`, param).then(
      res => {
        if (!!res.data.list) {
          dbg.info('[type.GET_SUBSCRIPT_VIDEO] response: %O', res)
          commit(type.GET_SUBSCRIPT_VIDEO, [...state.subscVideoItems, ...res.data.list])
        }
      },
      error => {
        error = pushErrorMessage(error)
        return Promise.reject(error)
      }
    )
  },
  [type.GET_TAG_ITEMS_ALL]({ commit, state, dispatch }, data) {
    let limit, offset
    limit = !!data.limit ? data.limit : ACQUIRED_MENUS_NUMBER
    offset = !!data.offset ? data.offset : 0

    dispatch(type.SET_CLOSED_ITEMS_LSKEY, data.userId)

    dbg.info('[type.GET_TAG_ITEMS_ALL]開始 tag:%s offset:%s limit: %s data:%O', data.tagId, offset, limit, data)
    commit(type.SET_CHANGE_PARTNER_RESET, data.isChangePartnerReset)
    if (data.isChangePartnerReset) dispatch(type.GET_ACCOUNT, data.accToken)

    const targetApi = data.tagId === 'history' ? ITEM_API.getHistoryList : ITEM_API.getTagItemsAll

    const filter = {}
    if (state.tagItemFilter.length > 0) {
      state.tagItemFilter.forEach(item => {
        filter[item.key] = item.id
      })
    }

    if (/^\w+$/.test(data.tagId) && !!data.accToken) {
      // console.log('-> tagId,TokenはOK [id:%s offset:%s limit: %s', data.tagId, offset, limit)
      return axiosInstance
        .get(targetApi, {
          headers: { token: data.accToken },
          data: {},
          params: {
            tag_id: data.tagId,
            offset: offset,
            limit: limit,
            ...filter,
          }
        })
        .then(
          res => {
            dbg.info('[playlist] 生のresponse:%O', res)
            //tagInfoセット
            if (data.tagId !== 'history') {
              commit(type.SET_TAG_INFO, {
                currentTag: data.tagId,
                isSeelater: !!res.data.isSeelater ? res.data.isSeelater : false,
                seelaterNum: !!res.data.seelaterNum ? +res.data.seelaterNum : 0
              })
            }

            dispatch(type.SET_RETURN_TABLIST, {
              tablist: [...res.data.tabList],
              tagId: data.tagId,
              resetItems: data.resetItems,
              offset: offset,
              limit: limit
            })
          },
          error => {
            console.log('こめ1')
            commit(type.GET_TAG_ITEMS_ALL, [{ error: { ...error } }])
            error = pushErrorMessage(error)
            return Promise.reject(error)
          }
        )
    } else {
      console.log('こめ2')
      const errMess = 'Error: Illegal tagId value.'
      commit(type.GET_TAG_ITEMS_ALL, [{ error: { error: errMess } }])
      return Promise.reject(errMess)
    }
  },
  [type.SET_RETURN_TABLIST]({ commit, state, dispatch }, data) {
    const now = new moment()
    const sendVideoMenus = {}
    const listInfo = []
    const rtn = [...data.tablist]

    //localStorageから終了メニューデータ取得・展開
    dispatch(type.GET_CLOSED_ITEMS_CACHE)

    for (let [index, tab] of rtn.entries()) {
      dbg.info('  %s tab情報〜[type:%s](%s件):%O', index + 1, tab.listType, tab.totalLen, tab)
      listInfo.push({
        listType: tab.listType,
        totalLen: !!tab.totalLen ? tab.totalLen : tab.itemList.length,
        offset: data.offset,
        limit: data.limit,
        tagId: data.tagId,
        resetItems: data.resetItems,
        acquiredItemList: []
      })
      for (let item of tab.itemList) {
        for (let tag of item.tags) {
          if (tag.id === TAROT_TAG_ID) {
            item['isTarotMenu'] = true
          }
        }
        item['localFavNum'] = !!item.favoriteNum ? item.favoriteNum : 0
        item['localFavStat'] = +item.isFavorite > 0
        listInfo[index].acquiredItemList.push({ ...item })
        //動画メニューチェック
        if (!!item.videoId) {
          sendVideoMenus[`id${item.id}`] = parseInt(item.videoId)
        }
      }
    }
    commit(type.GET_TAG_ITEMS_ALL, listInfo)
    commit(type.CHECK_HAVE_CLOSED_ITEMS)
    dispatch(type.SET_CLOSED_ITEMS_CACHE)
    if (!data.isPreview) dispatch(type.GET_SUBSCRIPT_VIDEO, sendVideoMenus)
  },
  [type.GET_CLOSED_ITEMS_CACHE]({ commit, state }) {
    let res = []
    try {
      res = JSON.parse(window.localStorage.getItem(state.closedItemsLSKEY))
      commit(
        type.GET_CLOSED_ITEMS_CACHE,
        !!res ? res.filter(item => !item.shown || (item.shown && item.closedItemToken === state.closedItemsTOKEN)) : []
      )
    } catch (e) {
      return []
    }
  },
  [type.SET_CLOSED_ITEMS_CACHE]({ commit, state }) {
    window.localStorage.setItem(state.closedItemsLSKEY, JSON.stringify(state.closedItems))
  },
  [type.SETSHOWN_CLOSED_ITEMS_CACHE]({ state }, ids) {
    return new Promise((resolve, reject) => {
      const up = state.closedItems
      ids.forEach(tgt => {
        up.forEach(item => {
          if (item.id === tgt) {
            item.shown = true
            item.closedItemToken = state.closedItemsTOKEN
          }
        })
      })
      try {
        window.localStorage.setItem(state.closedItemsLSKEY, JSON.stringify(up))
        resolve(true)
      } catch (e) {
        console.error(`Error: can't set to localStorage.`)
        reject(e)
      }
    })
  },
  [type.SET_CLOSED_ITEMS_LSKEY]({ commit, state }, uid) {
    // ログアウトでLS消えるので意味ないけどそのユーザーしか使えないので有益
    let res = ''
    const uidstr = `${uid}`
    const prm = 'profitable'
    for (let i = 0; i < uidstr.length; i++) {
      res += prm.charAt(+uidstr.charAt(i))
    }
    commit(type.SET_CLOSED_ITEMS_LSKEY, `${CLOSED_MENUS_LSKEY}_${res}`)
  },
  [type.SET_CLOSED_ITEMS_TOKEN]({ commit, state }) {
    commit(type.SET_CLOSED_ITEMS_TOKEN, new Date().getTime())
  },
  [type.GET_NEXT_TAG_ITEMS]({ commit, state, dispatch }, data) {
    dbg.info('次リストデータ取得開始 state:%O', state.subscrItemList)
    let resetItems = false
    let offset = 0
    const tgtList = state.subscrItemList
    const pastTagId = !!tgtList[0] ? (!!tgtList[0].tagId ? tgtList[0].tagId : null) : null
    const sendParams = { ...data }
    if (!!pastTagId && data.tagId === pastTagId) {
      //次のアイテムを取得する
      resetItems = false //念の為明示的に入れておく
      //トータルの多いほうを取得する
      let tempOffset
      let tempTotal = 0
      const reslen = []
      for (let tab of tgtList) {
        if (tab.itemList.length > Math.max(...reslen)) {
          tempOffset = tab.itemList.length
          tempTotal = tab.totalLen > tempTotal ? tab.totalLen : tempTotal
        }
        reslen.push(tab.itemList.length)
      }
      // dbg.info('結果 tempOffset: %s  tempTotal: %s', tempOffset, tempTotal)
      if (tempOffset < tempTotal) {
        offset = tempOffset
      } else {
        return
      }
    } else {
      //最初から別のタグデータを取得する(offsetは0, エラーが入っていた場合こちらのはず)
      resetItems = true
    }
    dispatch(type.GET_TAG_ITEMS_ALL, {
      userId: data.userId,
      tagId: data.tagId,
      accToken: data.accToken,
      offset: offset,
      resetItems: resetItems
    })
  },
  [type.GET_FILTERED_TAG_ITEMS]({ commit, state, dispatch }, data) {
    commit(type.SET_TAGITEM_FILTER, data.lists)
    dispatch(type.GET_TAG_ITEMS_ALL, {
      userId: data.userId,
      tagId: String(data.tagId),
      accToken: data.accToken,
      resetItems: true
    })
  },
  [type.RESET_TAGITEMS_FILTER]({commit}){
    commit(type.SET_TAGITEM_FILTER, [])
  },
  [type.RESET_TAG_ITEMS]({ commit }) {
    commit(type.RESET_TAG_ITEMS)
  },
  [type.SET_TAG_ITEM_HISTORY]({ commit, state }, data) {
    return axiosInstance
      .post(
        ITEM_API.setTagItemHistory,
        {
          item_id: data.menuId
        },
        {
          headers: { token: data.accToken }
        }
      )
      .catch(err => {
        console.error('Error: item_id %s の履歴を保存できませんでした %O', data.menuId, err)
      })
  },
  [type.SET_TAG_ITEM_HISTORY]({ commit, state }, data) {
    return axiosInstance
      .post(
        ITEM_API.setTagItemHistory,
        {
          item_id: data.menuId
        },
        {
          headers: { token: data.accToken }
        }
      )
      .catch(err => {
        console.error('Error: item_id %s の履歴を保存できませんでした %O', data.menuId, err)
      })
  },
  [type.SET_VIDEO_PLAY_HISTORY]({ commit, state }, data) {
    return axiosInstance
      .post(
        ITEM_API.setVideoPlayHistory,
        {
          item_id: data.menuId
        },
        {
          headers: { token: data.accToken }
        }
      )
      .catch(err => {
        console.error('Error: item_id %s の履歴を保存できませんでした %O', data.menuId, err)
      })
  },
  [type.SET_ITEM_FAVORITE]({ commit, state }, data) {
    const itemlist = state.subscrItemList
    const chklist = state.favCheckList

    //まず通常の変更状態をコミット
    commit(type.SET_FAV_STATUS, { menuId: data.menuId, stat: data.stat, incdec: true })

    //チェックリストにアイテムがあるか？
    // -> procstat: 0 処理する 1 処理するけどデータはある 2 処理しない
    let procstat = 0 //デフォルトで処理する
    let tgtchk, tgtitem
    let now = new Date().getTime()

    if (!!itemlist) {
      searchItems: for (let tab of itemlist) {
        for (let item of tab.itemList) {
          if (item.id === +data.menuId) {
            tgtitem = item
            break searchItems
          }
        }
      }
    }

    for (let item of chklist) {
      if (item.menuId === data.menuId) {
        tgtchk = { ...item }

        //一時保存してあるステータスと同じなら処理しない
        if (item.stat === data.stat) {
          procstat = 2 //処理しなくてもいい
        } else {
          procstat = 1 //処理する
          commit(type.DELETE_FAV_CHECKLIST_ITEM, data.menuId) //一旦削除
          clearTimeout(item.tmid)
        }
        break
      }
    }

    if (procstat < 2) {
      //タイマー開始する
      const tmid = setTimeout(() => {
        axiosInstance
          .post(
            ITEM_API.setItemFavorite,
            {},
            {
              headers: { token: data.accToken },
              params: {
                user_id: data.userId,
                item_id: data.menuId,
                fav: data.stat ? 1 : 0
              }
            }
          )
          .then(res => {
            /*
            // 一旦APIからの戻りは反映させないようにする
            if (res.data.response === 'OK') {
              commit(type.SET_FAV_STATUS, {
                menuId: +res.data.item_id,
                stat: +res.data.fav > 0,
                favNum: +res.data.total,
                setNumForce: true
              })
            }
             */
            commit(type.DELETE_FAV_CHECKLIST_ITEM, data.menuId)
          })
          .catch(err => {
            console.error(`Error: Can't set favorite flag [id:${data.menuId}]`)
          })

        commit(type.DELETE_FAV_CHECKLIST_ITEM, data.menuId)
      }, FAV_CHECK_TIME)

      //チェックデータをコミット
      tgtchk = {
        menuId: data.menuId,
        stat: data.stat,
        tmid: tmid,
        start: now
      }
      commit(type.SET_FAV_CHECKLIST, tgtchk)
    }
  },
  [type.RESET_FAV_CHECKLIST]({ commit }) {
    commit(type.RESET_FAV_CHECKLIST)
  },
  [type.GET_FAV_HISTORY]({ commit, state, dispatch }, data) {
    if (state.isChangePartnerReset) dispatch(type.GET_ACCOUNT, data.accToken)
    let getCount = 0
    let returnArr = []
    dispatch(type.SET_CLOSED_ITEMS_LSKEY, data.userId)

    const loadCheck = data => {
      const sendVideoMenus = {}

      //localStorageから終了メニューデータ取得・展開
      dispatch(type.GET_CLOSED_ITEMS_CACHE)

      getCount++
      returnArr.push({ ...data })
      if (getCount === 2) {
        if (returnArr[0].acquiredItemList.length > 0 || returnArr[1].acquiredItemList.length > 0) {
          for (let tab of returnArr) {
            if (tab.acquiredItemList.length > 0) {
              for (let item of tab.acquiredItemList) {
                for (let tag of item.tags) {
                  if (tag.id === TAROT_TAG_ID) {
                    item['isTarotMenu'] = true
                  }
                }
                item['localFavNum'] = !!item.favoriteNum ? item.favoriteNum : 0
                item['localFavStat'] = +item.isFavorite > 0
                //動画メニューチェック
                if (!!item.videoId) {
                  sendVideoMenus[`id${item.id}`] = parseInt(item.videoId)
                }
              }
            }
          }

          // sendVideoMenusにアイテムがあればdispatch
          if (Object.keys(sendVideoMenus).length > 0) {
            dispatch(type.GET_SUBSCRIPT_VIDEO, sendVideoMenus)
          }

          returnArr = returnArr.sort(
            ((key, order = 'asc') => {
              return (a, b) => {
                if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) return 0
                const varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key]
                const varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key]
                let comparison = 0
                if (varA > varB) {
                  comparison = 1
                } else if (varA < varB) {
                  comparison = -1
                }
                return order === 'desc' ? comparison * -1 : comparison
              }
            })('listType', 'asc')
          )

          commit(type.GET_TAG_ITEMS_ALL, returnArr)
          commit(type.CHECK_HAVE_CLOSED_ITEMS)
          dispatch(type.SET_CLOSED_ITEMS_CACHE)
        } else {
          const errMess = 'Error: 表示するデータが存在しません.'
          commit(type.GET_TAG_ITEMS_ALL, [{ error: { error: errMess } }])
          return Promise.reject(errMess)
        }
      }
    }

    axiosInstance
      .get(ITEM_API.getFavHistoryText, {
        headers: { token: data.accToken },
        data: {},
        params: {}
      })
      .then(
        res => {
          if (!!res.data) {
            loadCheck({
              listType: 1,
              totalLen: res.data.length,
              offset: 0,
              resetItems: true,
              acquiredItemList: res.data
            })
          }
        },
        error => {
          loadCheck({
            listType: 1,
            totalLen: 0,
            offset: 0,
            resetItems: true,
            acquiredItemList: []
          })
        }
      )

    axiosInstance
      .get(ITEM_API.getFavHistoryVideo, {
        headers: { token: data.accToken },
        data: {},
        params: {}
      })
      .then(
        res => {
          if (!!res.data) {
            loadCheck({
              listType: 2,
              totalLen: res.data.length,
              offset: 0,
              resetItems: true,
              acquiredItemList: res.data
            })
          }
        },
        error => {
          loadCheck({
            listType: 1,
            totalLen: 0,
            offset: 0,
            resetItems: true,
            acquiredItemList: []
          })
        }
      )
  },
  [type.RESET_VIDEO_ITEMS]({ commit }) {
    commit(type.RESET_VIDEO_ITEMS)
  },
  [type.SET_CHANGE_PARTNER_RESET]({ commit }, stat) {
    commit(type.SET_CHANGE_PARTNER_RESET, stat)
  },
  [type.SET_ITEM_SEELATER]({ commit, state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      const params = {
        tag_id: data.tagId,
        mode: data.stat ? 1 : 2
      }
      axiosInstance
        .post(ITEM_API.setSeeLater, params, {
          headers: { token: data.accToken }
        })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [type.SET_CATPAGE_REFERRER]({ commit }, link) {
    commit(type.SET_CATPAGE_REFERRER, link)
  },
  [type.SET_TEXT_DETAIL_OPEN]({ commit }, tgt = 0) {
    commit(type.SET_TEXT_DETAIL_OPEN, tgt)
  },
  [type.GET_CATEGORY_ITEMS]({ commit }, data) {
    return new Promise((resolve, reject) => {
      const tempToken = parseInt(new Date().getTime() * Math.random())
      axiosInstance
        .get(ITEM_API.getCategoryItems, {
          headers: { token: data.accToken },
          data: {},
          params: { category_id: data.categoryId, reflesh_token: tempToken }
        })
        .then(
          res => {
            if (!!res.data) {
              commit(type.GET_CATEGORY_ITEMS, res.data.tags)
            }
          },
          error => {
            console.error('Error:%O', error)
          }
        )
    })
  },
  [type.GET_SEELATER_ITEMS]({ commit }, data) {
    return new Promise((resolve, reject) => {
      const tempToken = parseInt(new Date().getTime() * Math.random())
      axiosInstance
        .get(ITEM_API.getSeeLaterItems, {
          headers: { token: data.accToken },
          data: {},
          params: { reflesh_token: tempToken }
        })
        .then(
          res => {
            if (!!res.data && +res.status === 200) {
              commit(type.GET_CATEGORY_ITEMS, res.data.tags)
            }
          },
          error => {
            console.error('Error:%O', error)
          }
        )
    })
  }
}

const mutations = {
  [type.GET_ITEMS](_state, itemData) {
    Object.assign(_state, { itemData })
  },
  [type.RESET_ITEMS](_state) {
    Object.assign(_state, { itemData: {} })
  },
  [type.GET_ITEM](_state, data) {},
  [type.SELECT_ITEM](_state, selected) {
    Object.assign(_state, { selected })
  },
  [type.RESET_SELECTED_ITEM](_state) {
    Object.assign(_state, { selected: initialState.selected })
  },
  [type.GET_ITEM_RECOMENDS](_state, recomends) {
    Object.assign(_state, { recomends })
  },
  [type.RESET_ITEM_RECOMENDS](_state) {
    Object.assign(_state, { recommends: [] })
  },
  [type.GET_SUBSCRIPT_VIDEO](_state, subscript_video_data) {
    Object.assign(_state, { subscVideoItems: subscript_video_data })
  },
  [type.GET_TAG_ITEMS_ALL](_state, listInfo) {
    //API取得リストをマージする
    // dbg.info('[commit] API取得リストをマージする %O state?:%O', listInfo, _state)
    const subscrItemList = []

    if ('error' in listInfo[0]) {
      Object.assign(_state, { subscrItemList: [{ error: { ...listInfo[0] } }] })
    } else {
      const tgtList = [..._state.subscrItemList]
      if (!listInfo[0].resetItems && _state.subscrItemList.length > 0 && !('error' in _state.subscrItemList[0])) {
        // dbg.info('[commit] リストを追加投入 %O tgt:%O', listInfo, tgtList)
        for (let [index, tab] of listInfo.entries()) {
          tgtList[index].itemList.push(...tab.acquiredItemList)
        }
        Object.assign(_state, { subscrItemList: [...tgtList] })
      } else {
        // dbg.info('[commit] リストを初期投入')
        for (let tab of listInfo) {
          subscrItemList.push({
            itemList: tab.acquiredItemList,
            totalLen: tab.totalLen,
            listType: tab.listType,
            tagId: tab.tagId
          })
        }
        Object.assign(_state, { subscrItemList: [...subscrItemList] })
      }
    }
  },
  [type.GET_CLOSED_ITEMS_CACHE](_state, data) {
    _state.closedItems = [...data]
  },
  [type.CHECK_HAVE_CLOSED_ITEMS](_state) {
    const now = new moment()
    const closedList = [..._state.closedItems]
    _state.subscrItemList.forEach(tab => {
      tab.itemList.forEach(item => {
        item['closed'] = false
        item['closeDatetime'] = null
        if (!!item.closedAt && /(?:19|20)\d\d-[01]\d-[0-3]\d [012]\d:[0-5]\d/.test(item.closedAt)) {
          item['closeDatetime'] = new moment(item.closedAt) // 日付データはここで入れる
          if (now.isBefore(item.closedAt)) {
            const idx = closedList.findIndex(i => i.id === item.id)
            if (idx >= 0) {
              closedList[idx].closedAt = item.closedAt
              closedList[idx].closeDatetime = item.closeDatetime
              closedList[idx].addedDatetime = now.format('YYYY-MM-DD HH:mm:ss')
              closedList[idx].closed = false
            } else {
              closedList.push({
                ...item,
                shown: false,
                addedDatetime: now.format('YYYY-MM-DD HH:mm:ss')
              })
            }
          } else {
            item['closed'] = true
          }
        }
      })
    })
    _state.closedItems = [...closedList]
  },
  [type.SET_CLOSED_ITEMS_LSKEY](_state, key) {
    _state.closedItemsLSKEY = key
  },
  [type.SET_CLOSED_ITEMS_TOKEN](_state, token) {
    _state.closedItemsTOKEN = token
  },
  [type.RESET_TAG_ITEMS](_state) {
    return new Promise((resolve, reject) => {
      _state.subscrItemList.splice(0)
      resolve()
    })
  },
  [type.SET_FAV_CHECKLIST](_state, data) {
    for (let item of _state.favCheckList) {
      if (item.menuId === data.menuId) {
        item = { ...item, ...data }
        return
      }
    }
    _state.favCheckList.push(data)
  },
  [type.SET_FAV_STATUS](_state, data) {
    const itemlist = _state.subscrItemList
    if (!!itemlist) {
      for (let tab of itemlist) {
        for (let item of tab.itemList) {
          if (item.id === +data.menuId) {
            item.localFavStat = data.stat
            item.localFavNum = data.setNumForce
              ? data.favNum
              : data.stat ? item.localFavNum + 1 : item.localFavNum > 0 ? item.localFavNum - 1 : 0
            return
          }
        }
      }
    }
  },
  [type.DELETE_FAV_CHECKLIST_ITEM](_state, menuId) {
    for (let [index, item] of _state.favCheckList.entries()) {
      if (item.menuId === menuId) {
        _state.favCheckList.splice(index, 1)
        return
      }
    }
  },
  [type.RESET_FAV_CHECKLIST](_state) {
    _state.favCheckList.splice(0)
  },
  [type.RESET_VIDEO_ITEMS](_state) {
    _state.subscVideoItems.splice(0)
  },
  [type.SET_CHANGE_PARTNER_RESET](_state, stat) {
    _state.isChangePartnerReset = stat
  },
  [type.SET_TAG_INFO](_state, data) {
    _state.tagInfo = { ...data }
  },
  [type.SET_CATPAGE_REFERRER](_state, link) {
    _state.catpageReferrer = link
  },
  [type.SET_TEXT_DETAIL_OPEN](_state, tgt) {
    _state.openedTextDetailID = tgt
  },
  [type.GET_CATEGORY_ITEMS](_state, tgt) {
    _state.categoryItems = [...tgt]
  },
  [type.SET_TAGITEM_FILTER](_state, data) {
    _state.tagItemFilter = [...data]
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/store/modules/item.js